import React, { useContext, useState } from 'react';
import auth from '../services/auth';
import { UserContext } from '../context';
import { history } from '../history';
import './login.css';

const Login = () => {
    const context = useContext(UserContext);
    const [myUser, setUser] = useState({ USERNAME: '', PASSWORD: '' });
    const [error, setError] = useState('');
    const [loading, setLoading] = useState(false);

    const handleInputChange = ev => {
        const { name, value } = ev.target;
        setUser(prevUser => ({ ...prevUser, [name]: value }));
        setError(''); // Limpa o erro ao digitar
    };

    const handleSubmit = ev => {
        ev.preventDefault();
        setLoading(true);
        setError('');

        auth.post('/lic/login', myUser, { auth: { username: 'Portal', password: 'Portal1163' }})
        .then(res => {            
            localStorage.setItem('delphireact-token', res.data.token);
            localStorage.setItem('user-role', res.data.role);
            localStorage.setItem('user-name', res.data.usuario);                        
            context.alterLogin(true, res.data.role);
            history.push('/');
        })
        .catch(() => {
            setError('Usuário ou Senha Inválidos');
        })
        .finally(() => {
            setLoading(false);
        });
    };

    return (
        <div className="limiter">
            <div className="container-login100">
                <div className="wrap-login100">
                    <div className="login100-form-title p-b-26">
                        {/* Logótipo da Compsoft - pode ser um SVG ou imagem */}
                        <div className="cs-logo-icon" style={{ margin: '0 auto 15px', width: '50px', height: '50px', fontSize: '24px' }}>C</div>
                        Compsoft
                    </div>
                    <form onSubmit={handleSubmit}>
                        <div className="wrap-input100 validate-input" data-validate="Insira nome de Usuário">
                            <input className="input100" type="text" name="USERNAME" placeholder="Usuário" onChange={handleInputChange} />
                        </div>
                        <div className="wrap-input100 validate-input">
                            <input className="input100" type="password" name="PASSWORD" placeholder="Senha" onChange={handleInputChange} />
                        </div>

                        {error && <p className="login-error-message">{error}</p>}

                        <div className="container-login100-form-btn">
                            <div className="wrap-login100-form-btn">
                                <div className="login100-form-bgbtn"></div>
                                <button className="login100-form-btn" disabled={loading}>
                                    {loading ? <div className="spinner"></div> : 'Login'}
                                </button>
                            </div>
                        </div>
                    </form>
                </div>
            </div>
        </div>
    );
};

export default Login;
